import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// Gaming Avatars - cute mascots for players
export const PLAYER_AVATARS = [
    { id: 'dragon', emoji: '🐉', name: 'Dragon', color: '#FF6B6B' },
    { id: 'unicorn', emoji: '🦄', name: 'Unicorn', color: '#C77DFF' },
    { id: 'phoenix', emoji: '🔥', name: 'Phoenix', color: '#FF9500' },
    { id: 'wolf', emoji: '🐺', name: 'Wolf', color: '#74C0FC' },
    { id: 'tiger', emoji: '🐯', name: 'Tiger', color: '#FFD43B' },
    { id: 'panda', emoji: '🐼', name: 'Panda', color: '#69DB7C' },
    { id: 'fox', emoji: '🦊', name: 'Fox', color: '#FFA94D' },
    { id: 'cat', emoji: '🐱', name: 'Cat', color: '#F783AC' },
    { id: 'owl', emoji: '🦉', name: 'Owl', color: '#9775FA' },
    { id: 'rabbit', emoji: '🐰', name: 'Rabbit', color: '#FDA7DF' },
];

// Rank badges with gaming style
export const RANK_BADGES = {
    1: { emoji: '👑', title: 'Champion', glow: '#FFD700' },
    2: { emoji: '🥈', title: 'Runner Up', glow: '#C0C0C0' },
    3: { emoji: '🥉', title: 'Third Place', glow: '#CD7F32' },
    default: { emoji: '🎮', title: 'Player', glow: '#39FF14' }
};

// Get consistent avatar for a username (hash-based)
export const getAvatarForUser = (username) => {
    if (!username) return PLAYER_AVATARS[0];
    let hash = 0;
    for (let i = 0; i < username.length; i++) {
        hash = ((hash << 5) - hash) + username.charCodeAt(i);
        hash = hash & hash;
    }
    return PLAYER_AVATARS[Math.abs(hash) % PLAYER_AVATARS.length];
};

export const ThemeProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(() => {
        const saved = localStorage.getItem('theme');
        return saved ? saved === 'dark' : true;
    });

    const [isFunMode, setIsFunMode] = useState(() => {
        const saved = localStorage.getItem('funMode');
        return saved ? saved === 'true' : false;
    });

    useEffect(() => {
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
        if (isDark) {
            document.documentElement.classList.remove('light');
        } else {
            document.documentElement.classList.add('light');
        }
    }, [isDark]);

    useEffect(() => {
        localStorage.setItem('funMode', isFunMode ? 'true' : 'false');
        if (isFunMode) {
            document.documentElement.classList.add('fun-mode');
        } else {
            document.documentElement.classList.remove('fun-mode');
        }
    }, [isFunMode]);

    const toggleTheme = () => setIsDark(!isDark);
    const toggleFunMode = () => setIsFunMode(!isFunMode);

    return (
        <ThemeContext.Provider value={{ 
            isDark, 
            toggleTheme, 
            isFunMode, 
            toggleFunMode,
            getAvatarForUser,
            RANK_BADGES 
        }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
